import { htmlEncode } from '../../../utils/escape.utils';
import { html } from 'lit';
import { selectColumnRenderer } from '../../common/customRenderers';
import { ActionsColumnValues, MitigationType, State } from '../../common/constants';
import { translateFn } from '../../../utils/translator.helper';
import { RiskManagementSideMenuEvents } from '../../sideMenus/common/common';

export function misconfigurationNameRenderer(rowData) {
  const misconfigurationName =
    Application.modules.riskManagement.controller.helpers.routinesTranslations.translateRoutineName(
      rowData?.item?.indicatorId
    );
  return html`<span class="cell-label">${misconfigurationName}</span>`;
}

export function actionsColumnRenderer(rowData) {
  if (!rowData.item.company.specifics.features.iorUsable) {
    return selectColumnRenderer.call(this, rowData, []);
  }

  const options = [] as Array<any>;

  const affectedDevicesCount = rowData.item.affectedDevices.reduce((acc, group) => {
    return acc + group.ids.length;
  }, 0);

  if (rowData.item.mitigation === MitigationType.AUTOMATIC && affectedDevicesCount > 0) {
    options.push({
      title: translateFn('Fix risk'),
      value: ActionsColumnValues.FIX_RISK,
      event: {
        name: RiskManagementSideMenuEvents.FIX_MISCONFIGURATIONS,
        detail: {
          indicatorsIds: [rowData.item.indicatorId],
          companyId: rowData.item.company._id,
        },
      },
    });
  }

  if (rowData.item.mitigation === MitigationType.AUTOMATIC) {
    options.push({
      title: translateFn('Roll back fix'),
      value: ActionsColumnValues.ROLLBACK_FIX,
      event: {
        name: RiskManagementSideMenuEvents.ROLLBACK_MISCONFIGURATIONS_INLINE,
        detail: {
          indicatorsIds: [rowData.item.indicatorId],
          companyId: rowData.item.company._id,
          hasFrat: rowData.item.hasFrat,
        },
      },
    });
  }

  if (rowData.item.state === State.IGNORED) {
    options.push({
      title: translateFn('Restore ignored risk'),
      value: ActionsColumnValues.RESTORE,
      event: {
        name: RiskManagementSideMenuEvents.RESTORE_MISCONFIGURATIONS,
        detail: {
          indicatorsIds: [rowData.item.indicatorId],
          companyId: rowData.item.company._id,
        },
      },
    });
  } else {
    options.push({
      title: translateFn('Ignore risk'),
      value: ActionsColumnValues.IGNORE,
      event: {
        name: RiskManagementSideMenuEvents.IGNORE_MISCONFIGURATIONS,
        detail: {
          indicatorsIds: [rowData.item.indicatorId],
          companyId: rowData.item.company._id,
        },
      },
    });
  }

  return selectColumnRenderer.call(this, rowData, options);
}
